import { Pagination } from "react-admin";

export const OrdersPagination = props =>
    <Pagination rowsPerPageOptions={[10, 25, 50, 100]} {...props} />